import t, { partial } from '../../../util/translation/translation';
import useConfig from '../../../util/useConfig';

const s = partial('shared');

const PreviewMessages = ({ formValues }) => {
  const config = useConfig();

  return (
    <div
      style={{
        maxWidth: 300,
        padding: 6,
        background: 'rgba(243, 243, 235, 0.75)',
        color: '#000',
        borderRadius: 12,
      }}
      className="flex flex-start flex-row"
    >
      <div style={{ margin: 4 }}>
        <div style={{ background: '#75747482', borderRadius: 10 }}>
          <img
            style={{ height: '36px', width: 'auto', padding: 6 }}
            src={config.club_logo}
            alt="logo"
            id="team-logo"
          />
        </div>
      </div>
      <div style={{ marginLeft: 5 }}>
        <span style={{ fontSize: 14, fontWeight: 700, marginTop: 10 }}>
          {formValues?.heading
            ? formValues?.heading.length > 30
              ? formValues?.heading.slice(0, 30) + '...'
              : formValues?.heading
            : config.club_name}
        </span>
        <p
          style={{
            whiteSpace: 'pre-line',
            marginTop: 0,
            lineHeight: 1.28,
          }}
        >
          {formValues?.message
            ? formValues?.message.length > 120
              ? formValues?.message.slice(0, 120) + '...'
              : formValues?.message
            : s('notice')}
        </p>
      </div>
    </div>
  );
};

export default PreviewMessages;
